import dayjs from "dayjs";
import RecordsLineUser from "./records-line-user";

/** Строка в таблице предварительной записи */
const RecordsLine = ({hour, users, height, timeWidth, userWidth, isToday, grafs, onSelectTime}) => {

  const position = (isToday && dayjs().hour() === hour) ? (height * dayjs().minute() / 60) : null;

  // Отображаемое время в минутах с начала дня
  const hStart = hour * 60;
  const hFinish = hStart + 60;
  const hGrafs = grafs.filter(i => i.startMin < hFinish && i.finishMin> hStart);

  const divTime = <div style={{width: timeWidth, height: height }} key={0}>
    <div>{hour}:00</div>
    {position !== null && <div className="records-line-time-today" style={{top: position - 3 }} />}
  </div>

  const divCols = [divTime, ...users.map(item => <RecordsLineUser 
    user={item}
    height={height}
    width={userWidth}
    key={item.id}
    position={position}
    grafs={hGrafs}
    start={hStart}
    finish={hFinish}
    onSelect={onSelectTime}
  />)]

  return<div className="records-line">
    {divCols}
  </div>

}

export default RecordsLine;